import { Component, HostListener, OnInit, AfterViewInit, ElementRef, Inject, Input } from '@angular/core';
import { slides } from './slides';
import { CookieService } from 'ngx-cookie-service';

declare var $: any;

@Component({
  selector: 'pru-carousel',
  templateUrl: './pru-carousel.component.html',
  styleUrls: ['./pru-carousel.component.scss']
})
export class PruCarouselComponent implements OnInit, AfterViewInit {
  @Input('carouselname') carouselName: string;
  @Input('linkname') linkName: string;
  htmlResponse: String;
  slides: slides[];
  slide: slides;
  errorMessage: String;
  elementRef: ElementRef;
  modalRequired: string;
  crName: string;
  crHash: string;
  globalInstance: any;
  displayLink: string;

  /**
   * 
   * @param elementRef 
   * @param _prucarouselService 
   */
  constructor(@Inject(ElementRef) elementRef: ElementRef, private _cookieService: CookieService) {
    this.elementRef = elementRef;
    this.crName = '';
    this.crHash = '';

  }

  ngOnInit() {
    this.loadCarouselData();
  }

  loadCarouselData() {
    this.crName = this.carouselName;
    this.crHash = '#' + this.carouselName;
    this.displayLink = this.linkName;
    this.slides = JSON.parse(sessionStorage.getItem('overlay'));
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyPressEvent(e: KeyboardEvent) {
    let targetElement = <HTMLElement>(<HTMLElement>e.target);
    if ((e.code == 'Enter' || e.code == 'Space') && targetElement.parentElement.className.includes('carousel-indicators')) {
      let parentElement = $(targetElement.closest('.carousel')),
        innerElment = parentElement.find('.carousel-inner'),
        slides = innerElment.find('.item'),
        slidenum = parseInt($(<HTMLElement>(<HTMLElement>e.target)).data('slideTo'), 10),
        focusElement = innerElment.find('.slideTitle')
      focusElement.removeAttr('tabindex');
      if (slidenum >= 0) {
        parentElement.carousel(slidenum),
          focusElement = slides.eq(slidenum).find('.slideTitle');
        focusElement.attr('tabindex', '-1').focus();
      }
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyDownEvent(e) {
    let element = <HTMLElement>(<HTMLElement>e.target);
    if (element.className.includes('carousel-control')) {
      if (e.code == 'Enter' || e.code == 'Space') {
        let parentElement = $(element.closest('.carousel')),
          innerElment = parentElement.find('.carousel-inner'),
          activeSlide = innerElment.find('.active'),
          slides = innerElment.find('.item'),
          focusElement = innerElment.find('.slideTitle'),
          activeindex = activeSlide.index(),
          slideto = $(element).data('slide'),
          slidemin = 0;
        let slidemax = slides.length - 1;
        focusElement.removeAttr('tabindex');
        
        if (slideto === 'prev') {
          if (activeindex > slidemin) {
            focusElement = slides.eq(activeindex - 1).find('.slideTitle');
          } else if (activeindex <= slidemin) {
            focusElement = slides.eq(slidemax).find('.slideTitle');
          }
        }
        if (slideto === 'next') {
          if (activeindex < slidemax) {
            focusElement = slides.eq(activeindex + 1).find('.slideTitle');
          } else if (activeindex >= slidemax) {
            focusElement = slides.eq(slidemin).find('.slideTitle');
          }
        }
        if (activeindex >= 0) {
          parentElement.carousel(slideto);
          focusElement.attr('tabindex', '-1').focus();
        }
      }
      if (e.code == 'Tab' && !e.shiftKey && $(element).hasClass('right')) { /* if tab on next btn */
        e.preventDefault();
        $(element.closest('.modal-content')).find('button.close').attr('tabindex', '-1').focus();
      };
    }
  }

  ngAfterViewInit() {
    if (this._cookieService.get('UserMigrated') || this._cookieService.get('migratedSession')) {
      $("#modal-helpoverlay").modal('show');
    }
    $('#modal-helpoverlay').on('shown.bs.modal', function () {
      $('#help-Title').focus();
    });
  }
}

